import React from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import styles from './PickerDetailsGetModal.module.scss';

const PickerDetailsGetModal = ({ show, onClose, onSubmit, loading }) => {
  const [formData, setFormData] = React.useState({
    pickerName: '',
    notes: '',
    type: 'CUSTOMER',
    pickerPhoneNumber: '',
  });

  const [errors, setErrors] = React.useState({
    pickerName: '',
    pickerPhoneNumber: '',
    notes: '',
  });

  const closeModalByCancelButton = () => {
    setFormData({
      pickerName: '',
      notes: '',
      type: 'CUSTOMER',
      pickerPhoneNumber: '',
    });
    setErrors({
      pickerName: '',
      pickerPhoneNumber: '',
      notes: '',
    });
    onClose();
  };

  const validateField = (name, value) => {
    let error = '';
    switch (name) {
      case 'pickerName':
        if (!value.trim()) {
          error = 'Name is required';
        } else if (value.trim().length < 2) {
          error = 'Name must be at least 2 characters';
        } else if (!/^[a-zA-Z\s]+$/.test(value.trim())) {
          error = 'Name can only contain letters and spaces';
        }
        break;
      case 'pickerPhoneNumber':
        if (value && !/^[0-9]{10}$/.test(value.replace(/[- ]/g, ''))) {
          error = 'Please enter a valid 10-digit phone number';
        }
        break;
      case 'notes':
        if (value && value.length > 500) {
          error = 'Notes cannot exceed 500 characters';
        }
        break;
      default:
        break;
    }
    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    const error = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key]);
      if (error) {
        newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(formData);
    }
  };

  return (
    <Modal
      className={styles.pickerDetailsModal}
      show={show}
      onHide={onClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Picker Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3'>
            <Form.Label>Pickup Person's Name</Form.Label>
            <Form.Control
              type='text'
              name='pickerName'
              value={formData.pickerName}
              onChange={handleChange}
              isInvalid={!!errors.pickerName}
              required
            />
            <Form.Control.Feedback type='invalid'>
              {errors.pickerName}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type='tel'
              name='pickerPhoneNumber'
              value={formData.pickerPhoneNumber}
              onChange={handleChange}
              isInvalid={!!errors.pickerPhoneNumber}
              placeholder='e.g., 1234567890'
            />
            <Form.Control.Feedback type='invalid'>
              {errors.pickerPhoneNumber}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Type</Form.Label>
            <Form.Control
              as='select'
              name='type'
              value={formData.type}
              onChange={handleChange}
            >
              <option value='TAXI'>Taxi</option>
              <option value='CUSTOMER'>Customer</option>
              <option value='OTHER'>Other</option>
            </Form.Control>
          </Form.Group>

          <Form.Group className='mb-3'>
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as='textarea'
              rows={3}
              name='notes'
              value={formData.notes}
              onChange={handleChange}
              isInvalid={!!errors.notes}
            />
            <Form.Control.Feedback type='invalid'>
              {errors.notes}
            </Form.Control.Feedback>
          </Form.Group>

          <div className='d-flex justify-content-end gap-2'>
            <Button variant='secondary' onClick={closeModalByCancelButton}>
              Cancel
            </Button>
            <Button variant='primary' type='submit' disabled={loading}>
              {loading ? 'Submitting...' : 'Submit'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default PickerDetailsGetModal;
